<template>
    <div
        class="doctorMenuInfo"
        :class="{ 'doctorMenuInfoUnpublished' : menu.status === constDoctorMenus.unpublished }">
        <doctor-menu-base-info
            :menu="menu"
            :user="user"
            :user-type="userType"
            :user-coupons="userCoupons"
            :consultation="consultation"
            :with-repeatable-date="withRepeatableDate">
        </doctor-menu-base-info>

        <p class="doctorMenuDescription">
            {{ shortMenuDescription(menu.description) }}
        </p>

        <hr class="divide">

        <doctor-info
            :doctor="menu.doctor"
            :early-schedule="menu.early_schedule"
            :with-doctor-profile-modal="withDoctorProfileModal"
            :doctor-introduction-type="doctorIntroductionType"
            :align-doctor-image="alignDoctorImage">
        </doctor-info>
    </div>
</template>

<script>
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'

    export default {
        props: {
            menu: {
                type: Object,
                required: true,
            },
            user: {
                type: Object|null,
                default: null,
            },
            userType: {
                type: String,
                default: 'user',
            },
            userCoupons: {
                type: Array,
                default: () => { return [] },
            },
            consultation: {
                type: Object,
                default: null,
            },
            withDoctorProfileModal: {
                type: Boolean,
                default: false,
            },
            withRepeatableDate: {
                type: Boolean,
                default: false,
            },
            doctorIntroductionType: {
                type: String,
                default: 'none',
            },
            alignDoctorImage: {
                type: String,
                default: 'start',
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                constDoctorMenus: constants.doctor_menus,
            }
        },

        methods: {
            /**
             * 詳細の省略表示
             *
             * @param {string} description
             * @return {string}
             */
            shortMenuDescription: function (description) {
                if (description && description.length > 150) {
                    return description.slice(0, 149) + '…'
                }
                return description
            },
        },
    }
</script>

<style lang="scss" scoped>
.doctorMenuInfoUnpublished {
    opacity: 0.5;
}

.doctorMenuDescription {
    color: #757C83;
    font-size: 14px;
    line-height: 21px;
    margin-top: 10px;
}

.divide {
    border-top: 1px dotted #ABB3BA;
}
</style>
